import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '../components/HomePage.vue'
import ChatOne from '../components/ChatOne.vue'
import TeacherAI from '../components/TeacherAI.vue'
import NewsInfo from '../components/NewsInfo.vue'
import CounselorAI from '../components/CounselorAI.vue'
import DoTest from '../components/DoTest.vue'
import IframeModule from '../components/IframeModule.vue'
import Visitor from '../components/Visitor.vue'
import LoginModule from '../components/LoginModule.vue'
import RecordModule from '../components/RecordModule.vue'
import ChatTrain from '../components/ChatTrain.vue'
import QuestionResult from '../components/QuestionResult.vue'
import ConclusionM from '../components/ConclusionM.vue'
import AddVisitorDialog from '../components/subassembly/AddVisitorDialog.vue'
import SelectVisitorDialog from '../components/subassembly/SelectVisitorDialog.vue'
import ListenDialog from '../components/subassembly/ListenDialog.vue'
import QuestionDialog from '../components/subassembly/QuestionDialog.vue'
import SimulationList from '../components/SimulationList.vue'
import SkillTraining from '../components/SkillTraining.vue'
import TrainDetail from '../components/TrainDetail.vue'
import EditNews from '../components/EditNews.vue'
import NewsLogin from '../components/NewsLogin.vue'
import NewsDetail from '../components/NewsDetail.vue'
import VisitorLogin from '../components/subassembly/VisitorLogin.vue'
import CommonHeader from '../components/subassembly/CommonHeader.vue'
import ReservationView from '../components/yuyue/ReservationView.vue'
import LocalCounselorAI from '../components/LocalCounselorAI.vue'

import DashBoard from '../components/yuyue/modals/DashBoard.vue'
import EduAppointment from '../components/yuyue/modals/EduAppointment.vue'
import LogoutModal from '../components/yuyue/modals/LogoutModal.vue'
import SideBar from '../components/yuyue/modals/SideBar.vue'
import SoundAppointment from '../components/yuyue/modals/SoundAppointment.vue'
import SystemSettings from '../components/yuyue/modals/SystemSettings.vue'
import UserDetailModal from '../components/yuyue/modals/UserDetailModal.vue'
import CheckInfoDialog from '../components/yuyue/modals/CheckInfoDialog.vue'

Vue.use(Router)
const router= new Router({
    mode: 'hash',
    routes: [
        {
            path: '/CheckInfoDialog',
            name: 'CheckInfoDialog',
            component: CheckInfoDialog
        },
        {
            path: '/DashBoard',
            name: 'DashBoard',
            component: DashBoard
        },
        {
            path: '/ReservationView',
            name: 'ReservationView',
            component: ReservationView
        },
        {
            path: '/EduAppointment',
            name: 'EduAppointment',
            component: EduAppointment
        },
        {
            path: '/LogoutModal',
            name: 'LogoutModal',
            component: LogoutModal
        },
        {
            path: '/SideBar',
            name: 'SideBar',
            component: SideBar
        },
        {
            path: '/SoundAppointment',
            name: 'SoundAppointment',
            component: SoundAppointment
        },
        {
            path: '/SystemSettings',
            name: 'SystemSettings',
            component: SystemSettings
        },
        {
            path: '/UserDetailModal',
            name: 'UserDetailModal',
            component: UserDetailModal
        },

    {
        path: '/CommonHeader',
        name: 'CommonHeader',
        component: CommonHeader
    },
    {
        path: '/NewsLogin',
        name: 'NewsLogin',
        component: NewsLogin
    },{
        path: '/NewsDetail',
        name: 'NewsDetail',
        component: NewsDetail
    },
    {
        path: '/manager-news',
        name: 'EditNews',
        component: EditNews,
        meta: { requiresAuth: true } 
    }, 
    {
        path: '/SkillTraining',
        name: 'SkillTraining',
        component: SkillTraining
    }, 
    {
        path: '/SimulationList',
        name: 'SimulationList',
        component: SimulationList
    },
    {
        path: '/',
        name: 'HomePage',
        component: HomePage,
        meta: { anchor: '' } 
    },
    {
        path: '/subFrame',
        name: 'IframeModule',
        component: IframeModule
    },
    {
      path: '/chat1',
      name: 'ChatOne',
      component: ChatOne
    },
    {
        path: '/teacherai',
        name: 'TeacherAI',
        component: TeacherAI
    },
    {
        path: '/NewsInfo',
        name: 'NewsInfo',
        component: NewsInfo
    },
    {
        path: '/CounselorAI',
        name: 'CounselorAI',
        component: CounselorAI
    },
    {
        path: '/local-counselor',
        name: 'LocalCounselorAI',
        component: LocalCounselorAI
    },
    {
        path: '/DoTest/:info',
        name: 'DoTest',
        component: DoTest
    },
    {
        path: '/visitor',
        name: 'Visitor',
        component: Visitor
    },
    {
        path: '/loginmodule',
        name: 'LoginModule',
        component: LoginModule
    },
    {
        path: '/RecordModule',
        name: 'RecordModule',
        component: RecordModule
    },
    {
        path: '/ChatTrain',
        name: 'ChatTrain',
        component: ChatTrain
    },
    {
        path: '/ConclusionM',
        name: 'ConclusionM',
        component: ConclusionM
    },
    {
        path: '/AddVisitorDialog',
        name: 'AddVisitorDialog',
        component: AddVisitorDialog
    },
    {
        path: '/SelectVisitorDialog',
        name: 'SelectVisitorDialog',
        component: SelectVisitorDialog
    },
    {
        path: '/QuestionResult',
        name: 'QuestionResult',
        component: QuestionResult
    },
    {
        path: '/TrainDetail',
        name: 'TrainDetail',
        component: TrainDetail
    },
    {
        path: '/ListenDialog',
        name: 'ListenDialog',
        component: ListenDialog
    },
    {
            path: '/VisitorLogin',
            name: 'VisitorLogin',
            component: VisitorLogin
    },
    {
        path: '/QuestionDialog',
        name: 'QuestionDialog',
        component: QuestionDialog
    },
    { path: '/anchor-pro', component: HomePage },
    { path: '/footerui', component: HomePage },
    { path: '/navigater-header', component: HomePage }
    ],

});


// ???????��??????
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const isAuthenticated = localStorage.getItem('isAuthenticated') // ??????????????
        if (!isAuthenticated) {
            next({
                path: '/',
                query: { redirect: to.fullPath } // ???????��???????????????????
            })
        } else {
            next() 
        }
    } else {
        next() 
    }
})
export default router;

